import { cn } from '~/lib/utils';

import { Logo } from './Logo';

export type LogoBrandSize = 'small' | 'medium' | 'large';

interface LogoBrandProps {
  size?: LogoBrandSize;
  className?: string;
}

const sizeConfig = {
  small: {
    logo: 24,
    gap: 8,
    fontSize: '16px',
  },
  medium: {
    logo: 28,
    gap: 10,
    fontSize: '20px',
  },
  large: {
    logo: 48,
    gap: 16,
    fontSize: '40px',
  },
};

export function LogoBrand({ size = 'medium', className }: LogoBrandProps) {
  const config = sizeConfig[size];

  return (
    <div className={cn('flex items-center', className)} style={{ gap: config.gap }}>
      <Logo size={config.logo} className="text-primary" />
      <span
        style={{
          fontFamily: '"Space Grotesk", sans-serif',
          fontSize: config.fontSize,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          color: 'inherit',
        }}
      >
        DeadDrop
      </span>
    </div>
  );
}
